/* global Promise */
import * as R from 'ramda';
import angular from 'angular';


export default function ImportMappingDialogController(
  $q,
  $scope,
  $rootScope,
  alerts,
  importDataService,
  importMappingResultDialog,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleAutoMap = _handleAutoMap;
  vm.handleCloseDialogClick = handleCloseDialogClick;
  vm.handleFormSubmit = handleFormSubmit;

  _activate();

  /** *******************************************
   * Event Handlers
   */
  function _handleAutoMap() {
    // console.log(vm.mappings);
    R.forEach((mapping) => {
      // console.log(mapping);
      const header = R.find(
        R.propEq('headerName', mapping.importField.displayName),
        vm.importHeaders
      );
      // console.log(header);
      if (header !== null) {
        mapping.importSetHeaderDataId = header.importSetHeaderDataId;
      }
    }, R.filter(
      R.propEq('importSetHeaderDataId', -1),
      vm.mappings
    ));

    // const selectedVendors = R.filter(
    //   R.propEq('isSelected', true),
    //   vm.vendorManager.vendors
    // );
  }

  function handleCloseDialogClick() {
    return ssDialogService.hide(ssDialogService.dialogs.global.importMappingsDialog);
  }

  function handleFormSubmit(form) {
    vm.processing = true;
    if (form.$invalid) {
      alerts.error('Error in data, import not processed.');
      return Promise.reject(new Error('Error in data, import not processed.'));
    }
    loaderService.showGlobalLoader = true;
    return _saveImportMappings()
      .then(() => importDataService.processImport(vm.importSet.importSetId)
        .then((response) => {
          loaderService.showGlobalLoader = false;
          const isSuccess = response.data;

          if (!isSuccess) {
            alerts.error('An error occurred during the import. Please contact your system administrator.');
            return Promise.reject(
              new Error('An error occurred during the import. Please contact your system administrator.')
            );
          }
          alerts.success('The import is successful. Getting more details ...');
          loaderService.showGlobalLoader = true;
          return importDataService.getImportDetails(vm.importSet.importEntityTypeId, vm.importSet.importSetId)
            .then((importResponse) => {
              loaderService.showGlobalLoader = false;
              const importResult = importResponse.data;

              _broadcastResults();

              // Display result;
              vm.processing = false;
              const dfdImportResult = _displayImportResult(importResult);

              if (vm.refreshCallBack) {
                vm.refreshCallBack(importResult);
              }
              return dfdImportResult;
            });
        }));
  }

  /** *******************************************
   * Private Functions
   */

  function _activate() {
    loaderService.showGlobalLoader = true;
    return _refreshImportMappings()
      .then(
        _refreshImportHeaders()
          .then(() => {
            loaderService.showGlobalLoader = false;
          })
      );
  }

  function _refreshImportHeaders() {
    return importDataService.getImportHeaders(vm.importSet.importSetId)
      .then((response) => {
        vm.importHeaders = response.data.result;
      });
  }

  function _refreshImportMappings() {
    return importDataService.getImportMappings(vm.importSet.importSetId)
      .then((response) => {
        vm.mappings = response.data.result;
        angular.forEach(vm.mappings, (item) => {
          item.importSetHeaderDataId = -1;
        });
      });
  }

  function _displayImportResult(result) {
    ssDialogService.dialogs.global.importMappingResultDialog = ssDialogService.alert(
      importMappingResultDialog.getOptions({
        customerId: vm.customerId,
        importSetData: result,
        importSet: vm.importSet,
        title: vm.title,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.global.importMappingResultDialog);
  }

  function _saveImportMappings() {
    return importDataService.saveImportMappings(vm.importSet.importSetId, vm.mappings)
      .then((saveMappingResponse) => {
        const success = saveMappingResponse.data;
        if (success === 'false') {
          alerts.error('Error occurred while saving the import mappings.');
          return Promise.reject(new Error('Error occurred while saving the import mappings.'));
        }
        alerts.success('The import mappings have been saved successfully. Processing import now...');
        return ssDialogService.hide(ssDialogService.dialogs.global.importMappingsDialog);
      });
  }

  function _broadcastResults() {
    switch (vm.importSet.importEntityTypeId) {
      case 1:
        /** Users */
        $rootScope.$broadcast('refreshUsers');
        break;
      case 2:
        /** VM Vendors  */
        $rootScope.$broadcast('initVMPage');
        break;
      case 3:
        /** BCP Servers */
        $rootScope.$broadcast('refreshBCPServers');
        $rootScope.$broadcast('setDocumentRegenerateFlag');
        break;
      case 4:
        /** BCP Workstations */
        $rootScope.$broadcast('refreshBCPWorkstations');
        $rootScope.$broadcast('setDocumentRegenerateFlag');
        break;
      case 5:
        /** Findings */
        $rootScope.$broadcast('refreshAMFindingCategories', { auditId: vm.importSet.entityId });
        break;
      case 6:
        /** AT Preparation Items */
        $rootScope.$broadcast('refreshAMPreparationItemCategories', { auditId: vm.importSet.entityId });
        break;
      default:
        break;
    }
  }
}

ImportMappingDialogController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'alerts',
  'importDataService',
  'importMappingResultDialog',
  'loaderService',
  'ssDialogService'
];
